<script>
  export default {
    name: 'MRWidgetMaintainerEdit',
    props: {
      maintainerEditAllowed: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
  };
</script>

<template>
  <section class="mr-info-list mr-links">
    <p v-if="maintainerEditAllowed">
      {{ s__("mrWidget|Allows edits from maintainers") }}
    </p>
  </section>
</template>



// WEBPACK FOOTER //
// vue_merge_request_widget/components/mr_widget_maintainer_edit.vue